import React, {Component} from 'react';

class MemberTraitLine extends Component{
    render() {
            if(this.props.trait.total > 0)
            {
                let bgColor = this.props.index % 2 ? 'bg-slate-200' : '';
                let traitName = this.props.trait.name.split('_')[1];
                let traitSet = this.props.trait.name.split('_')[0];
                let traitSetNumber = traitSet.split('Set')[1];
                return(
                    <div className={`${bgColor} flex text-left px-1`}>
                        <div className='pl-2 basis-1/4 leading-8'>{this.props.trait.name.split('_')[1]}</div>
                        <div className='flex basis-2/4 flex-row gap-2 grow'>
                            {this.props.trait.tier1 > 0 ? 
                                <div className='flex flex-column'>
                                    <div className={`text-center hexagon hexagon-style1`}>
                                        <div className={`synergy ${this.props.trait.name.split('_')[1]}`}>
                                            <img style={{filter: 'brightness(0)'}}src={`/traits/trait_icon_${traitSetNumber}_${traitName.toLowerCase()}.png`} alt={this.props.trait.name.split('_')[1]}/>
                                        </div>
                                    </div>
                                    <div className='align-middle' style={{ lineHeight: '29px' }}>x {this.props.trait.tier1}</div>
                                </div>
                            : ''}
                            {this.props.trait.tier2 > 0 ? 
                                        <div className='flex flex-column'><div className={`text-center hexagon hexagon-style2`}>
                                                    <div className={`synergy ${this.props.trait.name.split('_')[1]}`}>
                                                    <img style={{filter: 'brightness(0)'}}src={`/traits/trait_icon_${traitSetNumber}_${traitName.toLowerCase()}.png`} alt={this.props.trait.name.split('_')[1]}/>
                                                    </div>
                                                </div><div className='align-middle' style={{ lineHeight: '29px' }}>x {this.props.trait.tier2}</div></div>
                            : ''}
                            {this.props.trait.tier3 > 0 ? 
                                        <div className='flex flex-column'><div className={`text-center hexagon hexagon-style3`}>
                                                    <div className={`synergy ${this.props.trait.name.split('_')[1]}`}>
                                                    <img style={{filter: 'brightness(0)'}}src={`/traits/trait_icon_${traitSetNumber}_${traitName.toLowerCase()}.png`} alt={this.props.trait.name.split('_')[1]}/>
                                                    </div>
                                                </div><div className='align-middle' style={{ lineHeight: '29px' }}>x {this.props.trait.tier3}</div></div>
                            : ''}
                            {this.props.trait.tier4 > 0 ? 
                                        <div className='flex flex-column'><div className={`text-center hexagon hexagon-style4`}>
                                                    <div className={`synergy ${this.props.trait.name.split('_')[1]}`}>
                                                    <img style={{filter: 'brightness(0)'}}src={`/traits/trait_icon_${traitSetNumber}_${traitName.toLowerCase()}.png`} alt={this.props.trait.name.split('_')[1]}/>
                                                    </div>
                                                </div><div className='align-middle' style={{ lineHeight: '29px' }}>x {this.props.trait.tier4}</div></div>
                            : ''}
                        </div>
                    
                        <div className='flex flex-column basis-1/7'>
                            <div className='align-middle' style={{lineHeight: '29px'}}>x {this.props.trait.total}</div>
                        </div>   
                        
                    </div>
                )        
           }
    }
}
export default MemberTraitLine